<template>
  <div class="services_section">
    <div class="cover_image_wrapper">
      <h2 class="cover_title">{{ checkBn ? headerText.text_bn : headerText.text_en }}</h2>
      <img src="../../../../assets/images/portal/cover-img.jpg" alt="" />
    </div>
    <div class="breadcrumb_wrapper">
      <b-container>
        <b-row>
          <b-col>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/portal/home">{{ $t('portal.home') }}</router-link></li>
                <li class="breadcrumb-item"><router-link to="/portal/all-services">{{ $t('portal.all_service') }}</router-link></li>
                <li class="breadcrumb-item"><a href="javascript:" @click="$router.go(-1)">{{ $t('portal.service_details') }}</a></li>
                <li class="breadcrumb-item active" aria-current="page">{{ $t('portal.circular') }}</li>
              </ol>
            </nav>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="service_details_wrapper">
      <b-container>
        <b-row>
          <b-col>
            <div class="service_details">
                <iq-card>
                    <template v-slot:headerTitle>
                        <h4 class="card-title">{{ $t('external_sidebar.circular') + ' ' + $t('globalTrans.search') }}</h4>
                    </template>
                    <template v-slot:body>
                        <b-row>
                          <b-col lg="6" md="6" sm="12" xs="12">
                              <b-form-group
                                class="row"
                                label-cols-sm="4"
                                :label="$t('globalTrans.fiscal_year')"
                                label-for="fiscal_year_id"
                              >
                                <b-form-select
                                plain
                                v-model="search.fiscal_year_id"
                                :options="fiscalYearList"
                                id="fiscal_year_id"
                                >
                                <template v-slot:first>
                                    <b-form-select-option :value="0">{{ $t('globalTrans.select') }}</b-form-select-option>
                                </template>
                                </b-form-select>
                              </b-form-group>
                          </b-col>
                          <b-col lg="6" sm="12">
                            <b-form-group
                              class="row"
                              label-cols-sm="3"
                              :label="$t('globalTrans.title')"
                              label-for="title"
                              >
                              <b-form-input
                                plain
                                v-model="search.title"
                                id="title"
                              >
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col lg="12" md="12" sm="12" xs="12">
                              <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search') }}</b-button>
                          </b-col>
                        </b-row>
                    </template>
                </iq-card>
                <b-row>
                  <b-col md="12">
                      <iq-card>
                        <template v-slot:headerTitle>
                            <h4 class="card-title">{{ $t('external_sidebar.circular') + ' ' + $t('globalTrans.list') }}</h4>
                        </template>
                        <template v-slot:body>
                            <b-overlay :show="unitLoad">
                            <b-row>
                                <b-col md="12" class="table-responsive">
                                <b-table bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                                    <template v-slot:cell(index)="data">
                                    {{ $n(data.index + pagination.slOffset) }}
                                    </template>
                                    <template v-slot:cell(deadline)="data">
                                      {{ data.item.deadline | dateFormat }}
                                    </template>
                                    <template v-slot:cell(detail)="data">
                                      <b-button title="View Details" v-b-modal.modal-5 variant=" iq-bg-success mr-1" size="sm" @click="details(data.item)"><i class="fa fa-eye m-0"></i></b-button>
                                    </template>
                                    <template v-slot:cell(action)="data">
                                      <a v-b-modal.modal-5 href="javascript:" title="Apply" @click="details(data.item)" variant=" iq-bg-primary" size="sm">
                                        {{ $t('portal.apply_now') }}
                                      </a>
                                    </template>
                                </b-table>
                                <b-pagination
                                    v-model="pagination.currentPage"
                                    :per-page="pagination.perPage"
                                    :total-rows="pagination.totalRows"
                                    @input="searchData"
                                    />
                                </b-col>
                            </b-row>
                            </b-overlay>
                        </template>
                      </iq-card>
                  </b-col>
                </b-row>
                <b-modal id="modal-5" size="xl" :title="ViewTitle" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
                    <Details :id="viewitemId" :serviceNameList="serviceNameList" :baseUrl="baseUrl" :key="viewitemId" ref="details"></Details>
                </b-modal>
            </div>
          </b-col>
        </b-row>
        <div class="service_btn_wrapper">
            <a href="javascript:" @click="$router.go(-1)" class="service_btn back_btn"><i class="fas fa-arrow-left"></i> {{ $t('portal.go_back') }}</a>
        </div>
      </b-container>
    </div>
  </div>
</template>
<script>
import Details from './Details'
import RestApi, { grantAllowanceServiceBaseUrl } from '@/config/api_config'
import Common from '@/mixins/portal/common'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
  mixins: [Common, ModalBaseMasterList],
  props: ['serviceUrl', 'serviceName'],
  components: {
    Details
  },
  data () {
    return {
      headerText: { text_en: '', text_bn: '' },
      unitLoad: false,
      baseUrl: grantAllowanceServiceBaseUrl,
      service: {},
      viewitemId: 0,
      search: {
        fiscal_year_id: 0,
        title: ''
      },
      serviceNameList: []
    }
  },
  created () {
    this.loadData()
    this.setHeaderText()
    this.search.fiscal_year_id = this.$store.state.currentFiscalYearId
  },
  computed: {
    fiscalYearList: function () {
      return this.$store.state.Portal.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    ViewTitle () {
      return this.$t('external_sidebar.circular') + ' ' + this.$t('globalTrans.details')
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('globalTrans.fiscalYear'), class: 'text-center' },
          { label: this.$t('elearning_config.circular_memo_no'), class: 'text-center' },
          { label: this.$t('globalTrans.title'), class: 'text-center' },
          { label: this.$t('grant_process.deadline'), class: 'text-center' },
          { label: this.$t('globalTrans.details'), class: 'text-center' },
          { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'fiscal_year_bn' },
          { key: 'circular_memo_no' },
          { key: 'title_bn' },
          { key: 'deadline' },
          { key: 'detail' },
          { key: 'action' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'fiscal_year_en' },
          { key: 'circular_memo_no' },
          { key: 'title_en' },
          { key: 'deadline' },
          { key: 'detail' },
          { key: 'action' }
        ]
      }

      return labels.map((item, index) => {
        return Object.assign(item, keys[index])
      })
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  methods: {
    details (item) {
      this.viewitemId = item.id
    },
    searchData () {
      this.loadData()
    },
    loadData () {
      this.unitLoad = true
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      RestApi.getData(grantAllowanceServiceBaseUrl, '/portal/bnswc-circular/circular-list', params).then(response => {
          if (response.success) {
            this.serviceNameList = response.serviceNameList
            this.$store.dispatch('setList', this.getRelationalData(response.data.data))
            this.paginationData(response.data)
          } else {
            this.$store.dispatch('setList', [])
          }
          this.unitLoad = false
      })
    },
    getRelationalData (data) {
      let fiscalYear = {}
      const listData = data.map(item => {
          fiscalYear = this.$store.state.Portal.commonObj.fiscalYearList.find(data => data.value === item.fiscal_year_id)
          const fiscalYearData = {
              fiscal_year_en: fiscalYear !== undefined ? fiscalYear.text_en : '',
              fiscal_year_bn: fiscalYear !== undefined ? fiscalYear.text_bn : ''
          }
          return Object.assign({}, item, fiscalYearData)
      })
      return listData
    },
    setHeaderText () {
      if (this.serviceName === undefined) {
        this.headerText = {
          text_en: '',
          text_bn: ''
        }
      } else {
        this.headerText = {
          text_en: this.serviceName.name,
          text_bn: this.serviceName.name_bn
        }
      }
    }
  }
}
</script>
